import Switch from 'react-switch';
import { toggleOnStyle, toggleOffStyle } from '../utils/pageStyles';
import { checkVariantsAcceptingOrders } from './utils/checkVariantsAcceptingOrders';
import { handleVariantsInventoryPolicyChange } from './utils/handleVariantsToggleChange';
import StockOutStatus from './utils/stockoutStatus';

const toggleOff = <div style={toggleOffStyle}>não</div>;
const toggleOn = <div style={toggleOnStyle}>sim</div>;

const StockOut = ({ productState, onChange }) => {
  const isSwitchEnabled =
    productState?.variants &&
    checkVariantsAcceptingOrders(productState?.variants) === StockOutStatus.All;

  return (
    <div className="row d-flex align-items-center my-3">
      <div className="col-4">
        <p className="fw-bold mb-0">Produto em estoque</p>
      </div>
      <div className="col-4">
        {
          <Switch
            width={70}
            className="mt-2 mt-md-4"
            onColor="#222222"
            offColor="#F2F2F2"
            onHandleColor="#222222"
            offHandleColor="#222222"
            checked={isSwitchEnabled}
            disabled={!productState?.status}
            onChange={status =>
              handleVariantsInventoryPolicyChange({
                isToggleOn: status,
                variants: productState?.variants,
                onChange,
              })
            }
            uncheckedIcon={toggleOff}
            checkedIcon={toggleOn}
          />
        }
      </div>
    </div>
  );
};

export default StockOut;
